/**
 * Global icon constants
 * Update icons here to change them everywhere in the application
 */

export const Icons = {
  delete: '🗑️',
  edit: '✏️',
  close: '×',
  dragHandle: '⋮⋮',
} as const;

